<packbo-loading [class.hidden]="!showLoading()" />

<div class="flex min-h-screen w-full max-w-full flex-col overflow-x-hidden">
    <packbo-navigation class="sticky top-0 z-10 print:hidden" />
    <div class="w-full max-w-full flex-1 overflow-x-hidden">
        <router-outlet />
    </div>
    <packbo-footer class="print:hidden" />
</div>
